import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { SectionHeaderComponent } from '../../common/section-header/section-header.component';
import { SectionComponent } from '../../layout/section/section.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-products-overview',
  standalone: true,
  imports: [CommonModule, ContainerComponent, SectionHeaderComponent, SectionComponent],
  templateUrl: './products-overview.component.html',
  styleUrls: ['./products-overview.component.scss']
})
export class ProductsOverviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productsOverview', { static: false }) productsOverview?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.productsOverview?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.productsOverview.nativeElement,
        'Products Overview',
        'products-overview-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
